module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Shirt-0b10106e662ff28e89a1c1696abd05db.svg";